import { render, staticRenderFns } from "./CustomerArriveRecord.vue?vue&type=template&id=6d94eb7c&"
import script from "./CustomerArriveRecord.vue?vue&type=script&lang=js&"
export * from "./CustomerArriveRecord.vue?vue&type=script&lang=js&"
import style0 from "./CustomerArriveRecord.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports